import { CHECADOR } from "../../Constants/Endpoinst";
import { ApiRequestInterceptor } from "../apiRequest";

export const fetchChecador = async () => {
    const method = "GET";

    const response = await ApiRequestInterceptor(
        CHECADOR.getChecador,
        method
    );

    if (response?.code === 200 && response?.data) {
        return response.data;
    }

    if (response?.statusCode === 200 && response?.body) {
        return JSON.parse(response.body);
    }

    const errorMessage =
        response?.data?.error ||
        response?.body ||
        "Error al obtener datos del checador";

    throw new Error(errorMessage);
};